<div class="container">
  <div class="admin-page-header">
    <h2 class="title admin-page-title">Sender</h2>
    <button mat-stroked-button class="refresh-table-button" (click)="refreshCurrentTab()">
      <mat-icon>refresh</mat-icon>
      Refrescar
    </button>
  </div>

  <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" (selectedIndexChange)="onTabChange($event)">
    <mat-tab label="Email">
      <div class="admin-page-header">
        <span class="summary-chip">Total: {{ senderEmails.totalElements }}</span>
      </div>
      <mat-card class="table-card">
        <app-data-table
          [dataSource]="senderEmails.content"
          [displayedColumns]="emailDisplayedColumns"
          [emptyMessage]="'No hay emails enviados.'"
          [showPaginator]="true"
          [length]="senderEmails.totalElements"
          [pageSize]="senderEmails.size"
          [pageSizeOptions]="[50, 100, 150]"
          [rowClickable]="true"
          (rowClick)="emailDetail($event.row)"
          (page)="onPageChangeEmail($event)">
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>ID</th>
            <td mat-cell *matCellDef="let sender">{{ sender.id }}</td>
          </ng-container>
          <ng-container matColumnDef="from">
            <th mat-header-cell *matHeaderCellDef>From</th>
            <td mat-cell *matCellDef="let sender">{{ sender.from }}</td>
          </ng-container>
          <ng-container matColumnDef="to">
            <th mat-header-cell *matHeaderCellDef>To</th>
            <td mat-cell *matCellDef="let sender">{{ sender.to }}</td>
          </ng-container>
          <ng-container matColumnDef="subject">
            <th mat-header-cell *matHeaderCellDef>Subject</th>
            <td mat-cell *matCellDef="let sender">{{ sender.subject }}</td>
          </ng-container>
          <ng-container matColumnDef="createdAt">
            <th mat-header-cell *matHeaderCellDef>Created At</th>
            <td mat-cell *matCellDef="let sender">{{ sender.createdAt | date: appService.FORMAT_DATETIME }}</td>
          </ng-container>
        </app-data-table>
      </mat-card>
    </mat-tab>

    <mat-tab label="SMS">
      <div class="admin-page-header">
        <span class="summary-chip">Total: {{ senderSMSs.totalElements }}</span>
      </div>
      <mat-card class="table-card">
        <app-data-table
          [dataSource]="senderSMSs.content"
          [displayedColumns]="smsDisplayedColumns"
          [emptyMessage]="'No hay SMS enviados.'"
          [showPaginator]="true"
          [length]="senderSMSs.totalElements"
          [pageSize]="senderSMSs.size"
          [pageSizeOptions]="[50, 100, 150]"
          [rowClickable]="true"
          (rowClick)="smsDetail($event.row)"
          (page)="onPageChangeSMS($event)">
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>ID</th>
            <td mat-cell *matCellDef="let sender">{{ sender.id }}</td>
          </ng-container>
          <ng-container matColumnDef="from">
            <th mat-header-cell *matHeaderCellDef>From</th>
            <td mat-cell *matCellDef="let sender">{{ sender.from }}</td>
          </ng-container>
          <ng-container matColumnDef="to">
            <th mat-header-cell *matHeaderCellDef>To</th>
            <td mat-cell *matCellDef="let sender">{{ sender.to }}</td>
          </ng-container>
          <ng-container matColumnDef="body">
            <th mat-header-cell *matHeaderCellDef>Body</th>
            <td mat-cell *matCellDef="let sender">{{ sender.body }}</td>
          </ng-container>
          <ng-container matColumnDef="createdAt">
            <th mat-header-cell *matHeaderCellDef>Created At</th>
            <td mat-cell *matCellDef="let sender">{{ sender.createdAt | date: appService.FORMAT_DATETIME }}</td>
          </ng-container>
        </app-data-table>
      </mat-card>
    </mat-tab>
  </mat-tab-group>
</div>
